import { render } from "./Home.vue?vue&type=template&id=33540542"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAT SING\\Desktop\\working area\\TatSingGroup-Web\\ts-consulting-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__